import React, { useState } from "react";
import axios from "axios";
import Otp from "./Otp"; // Import the Otp component
import "../CSS/Auth.css";
import LoaderButton from "./pageLoaders/LoaderButton";
import logo from "../assets/Logo icon.jpg";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";
//Code must be well formatted
function Auth({
  isOpen,
  setToken,
  setCustomerDetails,
  setupDetails,
  setView,
  setActiveIcon,
}) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });
  const [showOtp, setShowOtp] = useState(false); // State to manage OTP visibility
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const submit = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_AUTH_MICROSERVICE_URL}/auth/identify-customer`,
        formData
      );
      if (response.status === 200) {
        setShowOtp(true); // Show OTP component after successful submission
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("There was an error identifying the customer!", error);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    submit();
  };

  return (
    <>
      {isOpen && !showOtp && (
        <div className="flex h-full flex-1 flex-col justify-center lg:px-4">
          <div className="sm:mx-auto sm:w-full sm:max-w-sm">
            <h2
              className="dexkor-h2-text"
              style={{
                background: `linear-gradient(90deg, ${setupDetails?.widgetCustomizations.primaryColor} 0%, ${setupDetails?.widgetCustomizations.secondaryColor} 100%)`,
                backgroundClip: "text",
                color: "transparent",
              }}
            >
              {setupDetails?.widgetCustomizations.loginHeading ||
                `Welcome to ${
                  setupDetails?.widgetCustomizations.partnerName || "DexKor"
                }`}
            </h2>
            <p className="dexkor-auth-description pt-1">
              {setupDetails?.widgetCustomizations.loginDescription ||
                "Tell us a little about yourself so we can give you the best experience."}
            </p>
          </div>

          {/* <div className="mt-4 relative">
            <div>
              <ChevronLeftIcon
                onClick={() => {
                  setView("LandingWindow");
                  setActiveIcon("home");
                }}
                className="w-5 h-5 text-blue-800 absolute left-0.5 cursor-pointer"
              />
            </div>
            <div className="flex flex-col items-center gap-y-3">
              <div className="text-blue-800 font-semibold text-base">
                Welcome to DexKor
              </div>
              <div>
                <img src={logo} alt="Brand-icon" className="w-12 h-12" />
              </div>
              <div className="text-sm font-semibold">
                Tell us a little about yourself so we can give you the best
                experience.
              </div>
            </div>
          </div> */}
          <div className="xl:mt-5 lg:mt-3 md:mt-2 sm:mt-1 xs-0">
            <form onSubmit={handleSubmit} className="space-y-6 sm:space-y-3">
              <div>
                <div>
                  <label
                    htmlFor="name"
                    className="flex block text-sm font-medium leading-6 text-gray-900"
                  >
                    Name
                  </label>
                  <div className="mt-1">
                    <input
                      id="name"
                      name="name"
                      placeholder="John Doe"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      autoComplete="name"
                      className="dexkor-form-input"
                    />
                  </div>
                </div>
              </div>

              <div>
                <label
                  htmlFor="email"
                  className="flex block text-sm font-medium leading-6 text-gray-900"
                >
                  Email address
                </label>
                <div className="mt-1">
                  <input
                    id="email"
                    placeholder="example@example.com"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    autoComplete="email"
                    className="dexkor-form-input"
                  />
                </div>
              </div>

              <div>
                <div>
                  <label
                    htmlFor="phone"
                    className="flex block text-sm font-medium leading-6 text-gray-900"
                  >
                    Phone Number
                  </label>
                  <div className="mt-1">
                    <input
                      id="phone"
                      placeholder="1234567890"
                      name="phone"
                      type="number"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      autoComplete="tel"
                      className="dexkor-form-input"
                    />
                  </div>
                </div>
              </div>

              <div>
                {loading ? (
                  <LoaderButton setupDetails={setupDetails} />
                ) : (
                  <button
                    type="submit"
                    aria-label="submit"
                    className="dexkor-form-submit-button"
                    style={{
                      background: `linear-gradient(90deg, ${setupDetails?.widgetCustomizations.secondaryColor} 0%, ${setupDetails?.widgetCustomizations.primaryColor} 100%)`,
                    }}
                  >
                    Submit
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      )}
      {showOtp && (
        <Otp
          customerData={formData} // Pass customer data to Otp component
          setShowOtp={setShowOtp}
          setToken={setToken}
          setCustomerDetails={setCustomerDetails}
          resendOTP={submit}
          setupDetails={setupDetails}
          setView={setView}
        />
      )}
    </>
  );
}

export default Auth;
